import { Typography, IconButton, Icon, ICONS_ENUM } from '@sanlam-glacier/app-common/components';
import styles from '../../widget/widget.module.scss';
import { PropsWithChildren } from 'react';
import { WidgetType } from 'modules/dashboard/types';
import { downloadExcelText } from '../../grid-layout/layouts/layoutUtils/helpContent';
import clsx from 'clsx';

interface WidgetActionsProps {
  type: WidgetType;
  isHidable?: boolean;
  isWidgetHidden: boolean;
  customActionIcon?: string;
  customActionText?: string;
  hideMoreButton?: boolean;
  onHideToggle: () => void;
  onInfoClick?: () => void;
  onReload: () => void;
  isReloadDisabled: boolean;
}

// For WidgetActions
export const WidgetActions = ({
  type,
  isHidable,
  isWidgetHidden,
  customActionIcon,
  customActionText,
  hideMoreButton,
  onHideToggle,
  onInfoClick,
  onReload,
  isReloadDisabled
}: PropsWithChildren<WidgetActionsProps>) => {
  return (
    <div className={styles.actionBtnContainer}>
      {isHidable && (
        <div className={styles.hideContainer}>
          {type === WidgetType.personalDetails && (
            <Typography
              data-testid={`${type}HideLabel`}
              variant={Typography.VARIANT.B4}
              className={styles.hideText}
              weight={Typography.WEIGHT.MEDIUM}
              color={Typography.COLOR.PRIMARY}
            >
              {isWidgetHidden ? 'Unhide private information' : 'Hide private information'}
            </Typography>
          )}
          <IconButton
            data-testid={`${type}HideButton`}
            size={IconButton.SIZE.XX_SMALL}
            variant={IconButton.VARIANT.TERTIARY}
            onClick={onHideToggle}
          >
            <Typography color={Typography.COLOR.PRIMARY}>
              <Icon
                data-testid={`${type}HideIcon`}
                icon={
                  isWidgetHidden
                    ? ICONS_ENUM.ACTION_2_VISIBILITY
                    : ICONS_ENUM.ACTION_2_VISIBILITY_OFF
                }
              />
            </Typography>
          </IconButton>
        </div>
      )}

      {customActionIcon && (
        <IconButton
          data-testid={`${type}${customActionIcon}Button`}
          onClick={onInfoClick}
          size={IconButton.SIZE.XX_SMALL}
          variant={IconButton.VARIANT.TERTIARY}
          className={clsx(customActionText === downloadExcelText && styles.downloadExcelButton)}
        >
          <Typography color={Typography.COLOR.PRIMARY}>
            <Icon data-testid={`${type}${customActionIcon}Icon`} icon={customActionIcon} />
          </Typography>
          {customActionText && (
            <Typography
              color={Typography.COLOR.PRIMARY}
              variant={Typography.VARIANT.B4}
              weight={Typography.WEIGHT.MEDIUM}
            >
              {customActionText}
            </Typography>
          )}
        </IconButton>
      )}

      {!hideMoreButton && !customActionIcon && onInfoClick && (
        <IconButton
          onClick={onInfoClick}
          size={IconButton.SIZE.XX_SMALL}
          variant={IconButton.VARIANT.TERTIARY}
        >
          <Typography color={Typography.COLOR.PRIMARY}>
            <Icon icon={ICONS_ENUM.NAVIGATION_MORE_VERT} />
          </Typography>
        </IconButton>
      )}

      <IconButton
        data-testid={`${type}ReloadButton`}
        onClick={onReload}
        size={IconButton.SIZE.XX_SMALL}
        variant={IconButton.VARIANT.TERTIARY}
        disabled={isReloadDisabled}
      >
        <Icon data-testid={`${type}ReloadIcon`} icon={ICONS_ENUM.NAVIGATION_REFRESH} />
      </IconButton>
    </div>
  );
};
